(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-marquee]').forEach(function (marquee) {
    var toggle = marquee.querySelector('[data-marquee-toggle]');
    if (!toggle) return;

    var pauseIcon = toggle.querySelector('[data-icon-pause]');
    var playIcon = toggle.querySelector('[data-icon-play]');

    toggle.addEventListener('click', function () {
      var paused = marquee.dataset.paused === 'true';
      marquee.dataset.paused = String(!paused);
      toggle.setAttribute('aria-pressed', String(!paused));
      pauseIcon.hidden = !paused;
      playIcon.hidden = paused;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    var body = document.querySelector('[data-page-cart-body]');
    var shipping = document.querySelector('[data-page-cart-shipping]');
    var summary = document.querySelector('[data-page-cart-summary]');
    var subtotalEl = document.querySelector('[data-page-cart-subtotal]');
    if (!body) return;

    function render(cart) {
      if (summary) summary.hidden = cart.item_count === 0;
      if (subtotalEl) subtotalEl.textContent = window.GasCart.formatMoney(cart.total_price, cart.currency);

      body.innerHTML = window.GasCart.renderLines(cart, {
        emptyLabel: body.dataset.emptyLabel,
        emptyCtaLabel: body.dataset.emptyCtaLabel,
        emptyCtaHref: body.dataset.emptyCtaHref,
      });

      if (shipping) {
        var threshold = Number(shipping.dataset.threshold || 0) * 100;
        shipping.innerHTML = window.GasCart.renderShippingBar(cart, threshold);
      }
    }

    window.GasCart.bindLineActions(body);
    document.addEventListener('cart:updated', function (event) {
      render(event.detail);
    });

    var discountForm = document.querySelector('[data-cart-discount-form]');
    if (discountForm) {
      discountForm.addEventListener('submit', function (event) {
        event.preventDefault();
        var code = discountForm.querySelector('#cart-discount-code').value.trim();
        if (!code) return;
        window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart');
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["category-carousel"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.cat').forEach(function (cat) {
    var viewport = cat.querySelector('[data-cat-viewport]');
    var next = cat.querySelector('[data-cat-next]');
    if (!viewport || !next) return;
    next.addEventListener('click', function () {
      viewport.scrollBy({ left: viewport.clientWidth * 0.8, behavior: 'smooth' });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {
    var content = document.querySelector('[data-collection-content]');
    if (!content) return;

    var form = content.querySelector('[data-collection-filter-form]');
    var sectionId = content.id.replace('collection-content-', '');

    // Plain scrollIntoView({block: 'start'}) lands the element's top at
    // document y=0, which the sticky/fixed navbar (sections/header.liquid)
    // then covers — on a single-column mobile grid that hides the first
    // row of results, reading as "pagination didn't scroll to the top" even
    // though it technically did. Subtracting the navbar's current height
    // (0 when it's still in normal flow, its real height once stuck fixed)
    // keeps the actual product grid visible below it. Runs on the next
    // frame so layout has settled after the just-swapped-in DOM.
    function scrollToContentTop(el) {
      requestAnimationFrame(function () {
        var navbarEl = document.querySelector('[data-navbar]');
        var offset = navbarEl && navbarEl.dataset.stuck === 'true' ? navbarEl.offsetHeight : 0;
        var top = el.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
      });
    }

    function swapContent(url) {
      var fetchUrl = new URL(url, window.location.origin);
      fetchUrl.searchParams.set('section_id', sectionId);
      fetch(fetchUrl.toString())
        .then(function (response) {
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var next = doc.querySelector('[data-collection-content]');
          if (!next) return;
          content.replaceWith(next);
          content = next;
          window.history.pushState({}, '', url);
          bind(next);
          if (window.GasWishlist) window.GasWishlist.bindButtons(next);
          scrollToContentTop(next);
        })
        .catch(function () {
          window.location.href = url;
        });
    }

    function serializeForm(formEl) {
      var params = new URLSearchParams(new FormData(formEl));
      var action = formEl.getAttribute('action');
      return (action || window.location.pathname) + '?' + params.toString();
    }

    function bind(root) {
      var rootForm = root.querySelector('[data-collection-filter-form]');
      if (rootForm) {
        rootForm.addEventListener('submit', function (event) {
          event.preventDefault();
          swapContent(serializeForm(rootForm));
        });
      }

      var sortSelect = root.querySelector('[data-filter-sort]');
      if (sortSelect && rootForm) {
        sortSelect.addEventListener('change', function () {
          swapContent(serializeForm(rootForm));
        });
      }

      root.querySelectorAll('.plp-chip a, .plp-pagination a').forEach(function (link) {
        link.addEventListener('click', function (event) {
          event.preventDefault();
          swapContent(link.getAttribute('href'));
        });
      });

      var drawer = root.querySelector('[data-filters-drawer]');
      var openBtn = root.querySelector('[data-filters-open]');
      if (openBtn) {
        openBtn.addEventListener('click', function () {
          openFiltersDrawer(drawer);
        });
      }
      root.querySelectorAll('[data-filters-close]').forEach(function (el) {
        el.addEventListener('click', function () {
          closeFiltersDrawer(drawer);
        });
      });
    }

    function openFiltersDrawer(drawer) {
      if (!drawer) return;
      drawer.dataset.open = 'true';
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeFiltersDrawer(drawer) {
      if (!drawer) return;
      drawer.dataset.open = 'false';
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var openDrawer = document.querySelector('[data-filters-drawer][data-open="true"]');
      if (openDrawer) closeFiltersDrawer(openDrawer);
    });

    bind(content);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var cartBadge = document.querySelector('[data-cart-badge]');
    var cartTrigger = document.querySelector('[data-cart-trigger]');

    function syncCartBadge(cart) {
      if (!cartBadge) return;
      cartBadge.hidden = cart.item_count === 0;
      cartBadge.textContent = String(cart.item_count);
    }

    cartTrigger?.addEventListener('click', function (event) {
      event.preventDefault();
      window.GasCart.open();
    });

    document.addEventListener('cart:updated', function (event) {
      syncCartBadge(event.detail);
    });

    document.querySelector('[data-search-trigger]')?.addEventListener('click', function () {
      window.GasSearch.open();
    });

    // Each top-level main-menu link with children gets its own
    // [data-dropdown] (see navbar-dropdown.liquid). Only one needs to be
    // open at a time — opening one closes the others.
    var dropdowns = Array.prototype.slice.call(document.querySelectorAll('[data-dropdown]'));

    function closeDropdown(dropdown) {
      var toggle = dropdown.querySelector('[data-dropdown-toggle]');
      dropdown.dataset.open = 'false';
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      if (dropdown.resetMegaMenu) dropdown.resetMegaMenu();
    }

    function closeAllDropdowns() {
      dropdowns.forEach(closeDropdown);
    }

    function isAnyDropdownOpen() {
      return dropdowns.some(function (dropdown) {
        return dropdown.dataset.open === 'true';
      });
    }

    // Each dropdown reproduces the original "Todo" mega menu behaviour:
    // hovering/focusing a left-column link that has children (a
    // [data-mega-trigger], see navbar-mega-link.liquid) swaps the
    // matching right-column panel into view and widens the menu to fit
    // it (via [data-panel-open]); hovering/focusing any OTHER left-column
    // link — one with no submenu — closes whatever panel is open, so
    // moving from a "has children" item straight to a plain link doesn't
    // leave the last panel stuck open. dropdown.resetMegaMenu is also
    // called by closeDropdown() so re-opening a dropdown always starts
    // clean instead of remembering the last hover.
    dropdowns.forEach(function (dropdown) {
      var toggle = dropdown.querySelector('[data-dropdown-toggle]');
      var menuEl = dropdown.querySelector('[data-dropdown-menu]');
      var megaLinks = Array.prototype.slice.call(dropdown.querySelectorAll('.navbar__mega-link'));
      var megaTriggers = Array.prototype.slice.call(dropdown.querySelectorAll('[data-mega-trigger]'));
      var megaPanels = Array.prototype.slice.call(dropdown.querySelectorAll('[data-mega-panel]'));

      var showMegaPanel = function (uid) {
        megaTriggers.forEach(function (trigger) {
          trigger.setAttribute('aria-expanded', String(trigger.dataset.megaTarget === uid));
        });
        megaPanels.forEach(function (panel) {
          panel.hidden = panel.dataset.megaPanel !== uid;
        });
        if (menuEl) menuEl.dataset.panelOpen = 'true';
      };

      dropdown.resetMegaMenu = function () {
        megaTriggers.forEach(function (trigger) {
          trigger.setAttribute('aria-expanded', 'false');
        });
        megaPanels.forEach(function (panel) {
          panel.hidden = true;
        });
        if (menuEl) menuEl.dataset.panelOpen = 'false';
      };

      megaLinks.forEach(function (link) {
        var activate = link.hasAttribute('data-mega-trigger')
          ? function () {
              showMegaPanel(link.dataset.megaTarget);
            }
          : dropdown.resetMegaMenu;
        link.addEventListener('mouseenter', activate);
        link.addEventListener('focus', activate);
      });

      if (!toggle) return;
      toggle.addEventListener('click', function (event) {
        event.stopPropagation();
        var isOpen = dropdown.dataset.open === 'true';
        dropdowns.forEach(function (other) {
          if (other !== dropdown) closeDropdown(other);
        });
        dropdown.dataset.open = String(!isOpen);
        toggle.setAttribute('aria-expanded', String(!isOpen));
      });
    });

    document.addEventListener('click', function (event) {
      var openDropdown = dropdowns.find(function (dropdown) {
        return dropdown.dataset.open === 'true' && !dropdown.contains(event.target);
      });
      if (openDropdown) closeDropdown(openDropdown);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeAllDropdowns();
    });

    var menuToggle = document.querySelector('[data-menu-toggle]');
    var mobileNav = document.querySelector('[data-nav-mobile]');

    if (menuToggle) {
      menuToggle.addEventListener('click', function () {
        var isOpen = mobileNav.dataset.open === 'true';
        mobileNav.dataset.open = String(!isOpen);
        menuToggle.setAttribute('aria-expanded', String(!isOpen));
      });
    }

    // Sticky header: hides on scroll-down, reappears on the slightest
    // scroll-up. lastDecisionY only moves when visibility actually flips
    // (or on a reversal) rather than every frame, so 1-2px of scroll jitter
    // doesn't cause hide/show flicker.
    var navbarEl = document.querySelector('[data-navbar]');
    var spacerEl = document.querySelector('[data-navbar-spacer]');
    // Captured once, while the navbar is still in normal flow (below the
    // announcement bar) — this is the scroll distance at which it should
    // switch from static to fixed, i.e. what position: sticky would do
    // natively if Shopify's per-section wrapper didn't break it.
    var stickyOffset = navbarEl ? navbarEl.getBoundingClientRect().top + window.scrollY : 0;
    var isStuck = false;
    var HIDE_THRESHOLD = 96;
    var DIRECTION_DELTA = 10;
    var lastDecisionY = window.scrollY;
    var isHidden = false;
    var ticking = false;

    function updateNavbarVisibility() {
      var currentScrollY = Math.max(window.scrollY, 0);
      var menuOpen = isAnyDropdownOpen() || (mobileNav && mobileNav.dataset.open === 'true');
      var delta = currentScrollY - lastDecisionY;

      if (!menuOpen && Math.abs(delta) > DIRECTION_DELTA) {
        var pastThreshold = currentScrollY > HIDE_THRESHOLD;
        isHidden = delta > 0 && pastThreshold;
        lastDecisionY = currentScrollY;
      }

      if (navbarEl && !menuOpen) {
        navbarEl.dataset.hidden = String(isHidden);
      }

      var shouldStick = currentScrollY >= stickyOffset;
      if (shouldStick !== isStuck) {
        isStuck = shouldStick;
        if (navbarEl) navbarEl.dataset.stuck = String(isStuck);
        if (spacerEl) spacerEl.style.height = isStuck ? navbarEl.offsetHeight + 'px' : '0px';
      }

      ticking = false;
    }

    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          requestAnimationFrame(updateNavbarVisibility);
          ticking = true;
        }
      },
      { passive: true }
    );

    updateNavbarVisibility();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var AUTOPLAY_INTERVAL = 6000;

    function HeroSlider(el) {
      this.el = el;
      this.track = el.querySelector('[data-track]');
      this.slides = Array.prototype.slice.call(el.querySelectorAll('[data-slide]'));
      this.dots = Array.prototype.slice.call(el.querySelectorAll('[data-dot]'));
      this.prevBtn = el.querySelector('.hero-arrow-prev');
      this.nextBtn = el.querySelector('.hero-arrow-next');
      this.index = 0;
      this.timer = null;
      this.autoplay = el.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      var self = this;

      if (this.slides.length > 1) {
        if (this.prevBtn) {
          this.prevBtn.addEventListener('click', function () {
            self.go(self.index - 1);
            self.restartAutoplay();
          });
        }
        if (this.nextBtn) {
          this.nextBtn.addEventListener('click', function () {
            self.go(self.index + 1);
            self.restartAutoplay();
          });
        }
        this.dots.forEach(function (dot, i) {
          dot.addEventListener('click', function () {
            self.go(i);
            self.restartAutoplay();
          });
        });
      }

      el.addEventListener('click', function (event) {
        self.handleClick(event);
      });
      el.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') self.closeHotspots();
      });
      document.addEventListener('click', function (event) {
        if (!el.contains(event.target)) self.closeHotspots();
      });

      if (this.autoplay && this.slides.length > 1) {
        el.addEventListener('mouseenter', function () {
          self.stopAutoplay();
        });
        el.addEventListener('mouseleave', function () {
          self.startAutoplay();
        });
        el.addEventListener('focusin', function () {
          self.stopAutoplay();
        });
        el.addEventListener('focusout', function () {
          self.startAutoplay();
        });
        this.startAutoplay();
      }
    }

    HeroSlider.prototype.startAutoplay = function () {
      if (!this.autoplay || this.timer) return;
      var self = this;
      this.timer = setInterval(function () {
        self.go(self.index + 1);
      }, AUTOPLAY_INTERVAL);
    };

    HeroSlider.prototype.stopAutoplay = function () {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    };

    HeroSlider.prototype.restartAutoplay = function () {
      if (!this.autoplay) return;
      this.stopAutoplay();
      this.startAutoplay();
    };

    HeroSlider.prototype.handleClick = function (event) {
      var trigger = event.target.closest('[data-hotspot]');
      if (trigger) {
        event.preventDefault();
        var wrapper = trigger.closest('.hotspot-wrapper');
        if (!wrapper) return;
        var isOpen = wrapper.classList.contains('is-open');
        this.closeHotspots();
        if (!isOpen) {
          wrapper.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
        }
        return;
      }
      if (!event.target.closest('.hotspot-card')) this.closeHotspots();
    };

    HeroSlider.prototype.closeHotspots = function () {
      this.el.querySelectorAll('.hotspot-wrapper.is-open').forEach(function (wrapper) {
        wrapper.classList.remove('is-open');
        var trigger = wrapper.querySelector('[data-hotspot]');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      });
    };

    HeroSlider.prototype.go = function (next) {
      var total = this.slides.length;
      this.index = (next + total) % total;

      if (this.track) this.track.style.transform = 'translateX(-' + this.index * 100 + '%)';

      this.slides.forEach((slide, i) => {
        var isActive = i === this.index;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', String(!isActive));
        var link = slide.querySelector('.hero-slide-link');
        if (link) link.setAttribute('tabindex', isActive ? '0' : '-1');
        var cta = slide.querySelector('.hero-cta');
        if (cta) cta.setAttribute('tabindex', isActive ? '0' : '-1');
        slide.querySelectorAll('[data-hotspot]').forEach(function (hotspot) {
          hotspot.setAttribute('tabindex', isActive ? '0' : '-1');
        });
      });
      this.dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === this.index);
        dot.setAttribute('aria-selected', String(i === this.index));
      });
      this.closeHotspots();
    };

    document.querySelectorAll('[data-hero-slider]').forEach(function (el) {
      new HeroSlider(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-bundle"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-bundle-table]').forEach(function (root) {
    var rows = Array.from(root.querySelectorAll('[data-bundle-row]'));
    var section = root.closest('.bundle');
    var totalEl = section.querySelector('[data-bundle-total]');
    var addAllBtn = section.querySelector('[data-bundle-add-all]');
    var currency = root.dataset.currency;
    var QTY_MIN = 1;
    var QTY_MAX = 10;
    var SUCCESS_DURATION = 2000;

    function formatMoney(cents) {
      if (window.GasCart) return window.GasCart.formatMoney(cents, currency);
      return '$' + (cents / 100).toFixed(2);
    }

    function clampQty(value) {
      return Math.min(QTY_MAX, Math.max(QTY_MIN, parseInt(value, 10) || QTY_MIN));
    }

    function rowQuantity(row) {
      var input = row.querySelector('[data-qty-input]');
      return clampQty(input.value);
    }

    function updateRow(row) {
      var qty = rowQuantity(row);
      var price = parseInt(row.dataset.price, 10) || 0;
      var lineTotal = qty * price;
      row.querySelector('[data-line-total]').textContent = formatMoney(lineTotal);

      var decreaseBtn = row.querySelector('[data-qty-decrease]');
      var increaseBtn = row.querySelector('[data-qty-increase]');
      if (decreaseBtn) decreaseBtn.disabled = qty <= QTY_MIN;
      if (increaseBtn) increaseBtn.disabled = qty >= QTY_MAX;

      return lineTotal;
    }

    function updateSummary() {
      var sum = 0;
      var anyChecked = false;
      rows.forEach(function (row) {
        var lineTotal = updateRow(row);
        var checkbox = row.querySelector('[data-bundle-checkbox]');
        if (checkbox.checked) {
          sum += lineTotal;
          anyChecked = true;
        }
      });
      if (totalEl) totalEl.textContent = formatMoney(sum);
      if (addAllBtn) addAllBtn.disabled = !anyChecked;
    }

    // Flashes a sparkle burst on `btn` for SUCCESS_DURATION, swapping its
    // text to `successText` for the same window when provided (icon-only
    // row buttons pass nothing and just get the sparkle).
    function flashSuccess(btn, successText) {
      if (successText) {
        if (!btn.dataset.originalLabel) btn.dataset.originalLabel = btn.textContent;
        btn.textContent = successText;
      }
      btn.classList.remove('is-success');
      // Force reflow so re-adding the class restarts the CSS animation if
      // this button was already mid-sparkle from a previous click.
      void btn.offsetWidth;
      btn.classList.add('is-success');
      window.setTimeout(function () {
        btn.classList.remove('is-success');
        if (successText && btn.dataset.originalLabel) {
          btn.textContent = btn.dataset.originalLabel;
        }
      }, SUCCESS_DURATION);
    }

    // Product-swap modal: fetches Shopify's related-products recommendations
    // for whichever row's swap button was clicked, and lets the shopper
    // replace that row's product/variant before it's ever added to cart.
    var modal = section.querySelector('[data-bundle-modal]');
    var modalTrack = modal ? modal.querySelector('[data-bundle-modal-track]') : null;
    var modalViewport = modal ? modal.querySelector('[data-bundle-modal-viewport]') : null;
    var modalPrev = modal ? modal.querySelector('[data-bundle-modal-prev]') : null;
    var modalNext = modal ? modal.querySelector('[data-bundle-modal-next]') : null;
    var activeSwapRow = null;

    function closeModal() {
      if (!modal) return;
      modal.hidden = true;
      activeSwapRow = null;
    }

    function renderModalProducts(products) {
      modalTrack.innerHTML = '';
      if (!products.length) {
        var empty = document.createElement('p');
        empty.className = 'bundle-modal__loading';
        empty.textContent = modal.dataset.emptyLabel;
        modalTrack.appendChild(empty);
        return;
      }

      products.forEach(function (product) {
        var variants = product.variants || [];
        var variant =
          variants.filter(function (v) {
            return v.available;
          })[0] ||
          variants[0] ||
          {};

        var card = document.createElement('div');
        card.className = 'bundle-modal__card';

        var imageWrap = document.createElement('span');
        imageWrap.className = 'bundle-modal__card-image';
        var imageUrl = product.featured_image || (product.images && product.images[0]);
        if (imageUrl) {
          var img = document.createElement('img');
          img.src = imageUrl;
          img.alt = '';
          img.loading = 'lazy';
          img.width = 160;
          img.height = 160;
          imageWrap.appendChild(img);
        }

        var title = document.createElement('span');
        title.className = 'bundle-modal__card-title';
        title.textContent = product.title;

        var price = document.createElement('span');
        price.className = 'bundle-modal__card-price';
        price.textContent = formatMoney(variant.price || product.price || 0);

        var selectBtn = document.createElement('button');
        selectBtn.type = 'button';
        selectBtn.className = 'btn btn-primary bundle-modal__select';
        selectBtn.textContent = modal.dataset.selectLabel;
        selectBtn.disabled = !variant.available;
        selectBtn.addEventListener('click', function () {
          applySwap(product, variant, imageUrl);
        });

        card.appendChild(imageWrap);
        card.appendChild(title);
        card.appendChild(price);
        card.appendChild(selectBtn);
        modalTrack.appendChild(card);
      });
    }

    function openModal(row) {
      if (!modal || !row.dataset.productId) return;
      activeSwapRow = row;
      modal.hidden = false;
      modalTrack.innerHTML = '<p class="bundle-modal__loading">' + modal.dataset.loadingLabel + '</p>';

      fetch(
        '/recommendations/products.json?product_id=' +
          encodeURIComponent(row.dataset.productId) +
          '&limit=10&intent=related'
      )
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          if (activeSwapRow === row) renderModalProducts(data.products || []);
        })
        .catch(function () {
          if (activeSwapRow === row) renderModalProducts([]);
        });
    }

    function applySwap(product, variant, imageUrl) {
      var row = activeSwapRow;
      if (!row || !variant.id) return;

      row.dataset.productId = product.id;
      row.dataset.variantId = variant.id;
      row.dataset.price = variant.price || product.price || 0;

      var imageEl = row.querySelector('[data-row-image]');
      if (imageEl) {
        imageEl.innerHTML = imageUrl ? '<img src="' + imageUrl + '" alt="" width="60" height="60" loading="lazy">' : '';
      }

      var titleEl = row.querySelector('[data-row-title]');
      if (titleEl) titleEl.textContent = product.title;

      var variantEl = row.querySelector('[data-row-variant]');
      if (variantEl) {
        var hasVariantTitle = variant.title && variant.title !== 'Default Title';
        variantEl.textContent = hasVariantTitle ? variant.title : '';
        variantEl.hidden = !hasVariantTitle;
      }

      var priceEl = row.querySelector('[data-row-unit-price]');
      if (priceEl) priceEl.textContent = formatMoney(variant.price || product.price || 0);

      var available = !!variant.available;
      var soldoutEl = row.querySelector('[data-row-soldout]');
      if (soldoutEl) soldoutEl.hidden = available;

      var checkboxEl = row.querySelector('[data-bundle-checkbox]');
      if (checkboxEl) checkboxEl.disabled = !available;

      var addBtnEl = row.querySelector('[data-action="add"]');
      if (addBtnEl) addBtnEl.disabled = !available;

      updateSummary();
      closeModal();
    }

    if (modal) {
      modal.querySelectorAll('[data-bundle-modal-close]').forEach(function (closeEl) {
        closeEl.addEventListener('click', closeModal);
      });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && !modal.hidden) closeModal();
      });
      if (modalPrev && modalViewport) {
        modalPrev.addEventListener('click', function () {
          modalViewport.scrollBy({ left: -modalViewport.clientWidth * 0.8, behavior: 'smooth' });
        });
      }
      if (modalNext && modalViewport) {
        modalNext.addEventListener('click', function () {
          modalViewport.scrollBy({ left: modalViewport.clientWidth * 0.8, behavior: 'smooth' });
        });
      }
    }

    rows.forEach(function (row) {
      var checkbox = row.querySelector('[data-bundle-checkbox]');
      var qtyInput = row.querySelector('[data-qty-input]');
      var decreaseBtn = row.querySelector('[data-qty-decrease]');
      var increaseBtn = row.querySelector('[data-qty-increase]');
      var swapBtn = row.querySelector('[data-swap-trigger]');
      var addBtn = row.querySelector('[data-action="add"]');

      checkbox.addEventListener('change', updateSummary);
      qtyInput.addEventListener('input', updateSummary);
      qtyInput.addEventListener('blur', function () {
        qtyInput.value = rowQuantity(row);
        updateSummary();
      });

      decreaseBtn.addEventListener('click', function () {
        qtyInput.value = Math.max(QTY_MIN, rowQuantity(row) - 1);
        updateSummary();
      });

      increaseBtn.addEventListener('click', function () {
        qtyInput.value = Math.min(QTY_MAX, rowQuantity(row) + 1);
        updateSummary();
      });

      if (swapBtn) {
        swapBtn.addEventListener('click', function () {
          openModal(row);
        });
      }

      addBtn.addEventListener('click', function () {
        if (!window.GasCart) return;
        addBtn.disabled = true;
        window.GasCart.addItem(row.dataset.variantId, rowQuantity(row))
          .then(function () {
            window.GasCart.open();
            flashSuccess(addBtn);
          })
          .finally(function () {
            addBtn.disabled = false;
          });
      });
    });

    if (addAllBtn) {
      addAllBtn.addEventListener('click', function () {
        if (!window.GasCart) return;
        var items = rows
          .filter(function (row) {
            return row.querySelector('[data-bundle-checkbox]').checked;
          })
          .map(function (row) {
            return { id: Number(row.dataset.variantId), quantity: rowQuantity(row) };
          });
        if (!items.length) return;

        addAllBtn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items }),
        })
          .then(function () {
            return window.GasCart.refresh();
          })
          .then(function () {
            window.GasCart.open();
            flashSuccess(addAllBtn, addAllBtn.dataset.successLabel);
          })
          .finally(function () {
            addAllBtn.disabled = false;
          });
      });
    }

    updateSummary();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-carousel"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.prod-carousel').forEach(function (carousel) {
    var viewport = carousel.querySelector('[data-prod-viewport]');
    var prev = carousel.querySelector('[data-prod-prev]');
    var next = carousel.querySelector('[data-prod-next]');
    if (!viewport) return;

    if (prev) {
      prev.addEventListener('click', function () {
        viewport.scrollBy({ left: -viewport.clientWidth * 0.8, behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        viewport.scrollBy({ left: viewport.clientWidth * 0.8, behavior: 'smooth' });
      });
    }
  });

  document.querySelectorAll('.recs').forEach(function (recs) {
    var viewport = recs.querySelector('[data-recs-track-viewport]');
    var prev = recs.querySelector('[data-recs-prev]');
    var next = recs.querySelector('[data-recs-next]');
    if (!viewport) return;

    if (prev) {
      prev.addEventListener('click', function () {
        viewport.scrollBy({ left: -viewport.clientWidth * 0.6, behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        viewport.scrollBy({ left: viewport.clientWidth * 0.6, behavior: 'smooth' });
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var pdpRoot = document.querySelector('[data-product-handle]');
    if (pdpRoot && window.GasRecentlyViewed) window.GasRecentlyViewed.track(pdpRoot.dataset.productHandle);
  })();

  document.querySelectorAll('[data-pdp-form]').forEach(function (form) {
    var variantsScript = form.querySelector('[data-pdp-variants]');
    var variantsJson = variantsScript ? JSON.parse(variantsScript.textContent) : [];
    var pdp = form.closest('.pdp') || document;
    var variantIdInput = form.querySelector('[data-pdp-variant-id]');
    var addBtn = form.querySelector('[data-pdp-add]');
    var addLabel = form.querySelector('[data-pdp-add-label]');
    var notifyBlock = pdp.querySelector('[data-pdp-notify]');
    var priceEl = pdp.querySelector('[data-pdp-price]');
    var optionGroups = Array.prototype.slice.call(pdp.querySelectorAll('[data-pdp-option]'));

    var addLabels = {
      add: addLabel ? addLabel.textContent.trim() : '',
    };

    function currentSelection() {
      return optionGroups.map(function (group) {
        var selected = group.querySelector('[data-selected="true"]');
        return selected ? selected.dataset.value : null;
      });
    }

    function findVariant(selection) {
      return variantsJson.find(function (variant) {
        return variant.options.every(function (value, i) {
          return selection[i] == null || value === selection[i];
        });
      });
    }

    function availableValuesForGroup(position, otherSelection) {
      var available = {};
      variantsJson.forEach(function (variant) {
        if (!variant.available) return;
        var matchesOthers = variant.options.every(function (value, i) {
          if (i === position - 1) return true;
          return otherSelection[i] == null || value === otherSelection[i];
        });
        if (matchesOthers) available[variant.options[position - 1]] = true;
      });
      return available;
    }

    function syncUI() {
      var selection = currentSelection();
      var variant = findVariant(selection);

      optionGroups.forEach(function (group) {
        var position = Number(group.dataset.optionPosition);
        var availableValues = availableValuesForGroup(position, selection);
        group.querySelectorAll('[data-option-value]').forEach(function (pill) {
          pill.dataset.selected = String(pill.dataset.value === selection[position - 1]);
          pill.dataset.unavailable = String(!availableValues[pill.dataset.value]);
        });
      });

      if (variant) {
        if (variantIdInput) variantIdInput.value = variant.id;
        if (priceEl) {
          var currentEl = priceEl.querySelector('.product-price__current');
          var oldEl = priceEl.querySelector('.product-price__old');
          var variantOnSale = !!(variant.compare_at_price && variant.compare_at_price > variant.price);
          if (currentEl && window.GasCart) {
            currentEl.textContent = window.GasCart.formatMoney(variant.price);
            currentEl.classList.toggle('product-price__current--sale', variantOnSale);
          }
          if (oldEl) {
            if (variantOnSale && window.GasCart) {
              oldEl.textContent = window.GasCart.formatMoney(variant.compare_at_price);
              oldEl.hidden = false;
            } else {
              oldEl.hidden = true;
            }
          }
        }
        if (addBtn) addBtn.disabled = !variant.available;
        if (addLabel)
          addLabel.textContent = variant.available ? addLabels.add : pdp.dataset.soldOutLabel || addLabels.add;
        if (notifyBlock) notifyBlock.hidden = variant.available;
      } else if (addBtn) {
        addBtn.disabled = true;
      }
    }

    optionGroups.forEach(function (group) {
      group.querySelectorAll('[data-option-value]').forEach(function (pill) {
        pill.addEventListener('click', function () {
          if (pill.dataset.unavailable === 'true') return;
          group.querySelectorAll('[data-option-value]').forEach(function (p) {
            p.dataset.selected = 'false';
          });
          pill.dataset.selected = 'true';
          syncUI();
        });
      });
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!variantIdInput || !variantIdInput.value) return;
      if (addBtn) addBtn.dataset.loading = 'true';
      window.GasCart.addItem(variantIdInput.value, 1).then(function () {
        if (addBtn) addBtn.dataset.loading = 'false';
        window.GasCart.open();
      });
    });

    syncUI();
  });

  document.querySelectorAll('[data-size-guide-open]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var dialog = document.querySelector('[data-size-guide]');
      if (dialog) dialog.showModal();
    });
  });

  (function () {
    var galleryMain = document.querySelector('[data-pdp-gallery-main]');
    if (!galleryMain) return;

    var images = Array.prototype.slice.call(galleryMain.querySelectorAll('[data-gallery-image]'));
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('[data-gallery-thumb]'));
    var lightbox = document.querySelector('[data-pdp-lightbox]');
    var lightboxImage = document.querySelector('[data-pdp-lightbox-image]');
    var cycleTimer = null;
    var activeIndex = 0;

    // Binds a finger-drag-to-navigate gesture to `el` and calls
    // onSwipe('prev' | 'next') once a horizontal drag clears the
    // threshold. Ignores mouse/pen (desktop already has click arrows) and
    // mostly-vertical drags, so it doesn't fight page scroll. Returns a
    // `wasDragged()` getter so callers can suppress a trailing click (e.g.
    // opening the lightbox) right after a swipe.
    function bindSwipe(el, onSwipe) {
      var startX = 0;
      var startY = 0;
      var dragging = false;
      var dragged = false;
      var SWIPE_THRESHOLD = 40;

      el.addEventListener(
        'pointerdown',
        function (event) {
          if (event.pointerType !== 'touch') return;
          startX = event.clientX;
          startY = event.clientY;
          dragging = true;
          dragged = false;
        },
        { passive: true }
      );

      el.addEventListener(
        'pointermove',
        function (event) {
          if (!dragging || event.pointerType !== 'touch') return;
          var dx = event.clientX - startX;
          var dy = event.clientY - startY;
          if (Math.abs(dx) > 10 || Math.abs(dy) > 10) dragged = true;
        },
        { passive: true }
      );

      function onPointerUp(event) {
        if (!dragging || event.pointerType !== 'touch') return;
        dragging = false;
        var dx = event.clientX - startX;
        var dy = event.clientY - startY;
        if (Math.abs(dx) >= SWIPE_THRESHOLD && Math.abs(dx) > Math.abs(dy)) {
          onSwipe(dx < 0 ? 'next' : 'prev');
        }
      }

      el.addEventListener('pointerup', onPointerUp, { passive: true });
      el.addEventListener('pointercancel', function () {
        dragging = false;
      });

      return function wasDragged() {
        return dragged;
      };
    }

    function setActiveIndex(index) {
      activeIndex = (index + images.length) % images.length;
      images.forEach(function (img) {
        img.classList.toggle('is-active', Number(img.dataset.index) === activeIndex);
      });
      thumbs.forEach(function (thumb) {
        var isActive = Number(thumb.dataset.index) === activeIndex;
        thumb.classList.toggle('is-active', isActive);
        thumb.setAttribute('aria-selected', String(isActive));
      });
      if (lightbox && lightbox.open && lightboxImage) {
        var activeImage = images[activeIndex];
        if (activeImage) {
          lightboxImage.src = activeImage.dataset.full || activeImage.src;
          lightboxImage.alt = activeImage.alt || '';
        }
      }
    }

    function startAutoCycle() {
      clearInterval(cycleTimer);
      if (images.length < 2) return;
      cycleTimer = setInterval(function () {
        setActiveIndex(activeIndex + 1);
      }, 5000);
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        setActiveIndex(Number(thumb.dataset.index));
        startAutoCycle();
      });
    });

    var prevArrow = galleryMain.querySelector('[data-gallery-prev]');
    var nextArrow = galleryMain.querySelector('[data-gallery-next]');

    if (prevArrow) {
      prevArrow.addEventListener('click', function () {
        setActiveIndex(activeIndex - 1);
        startAutoCycle();
      });
    }
    if (nextArrow) {
      nextArrow.addEventListener('click', function () {
        setActiveIndex(activeIndex + 1);
        startAutoCycle();
      });
    }

    var galleryWasDragged =
      images.length > 1
        ? bindSwipe(galleryMain, function (direction) {
            setActiveIndex(activeIndex + (direction === 'next' ? 1 : -1));
            startAutoCycle();
          })
        : function () {
            return false;
          };

    startAutoCycle();

    if (lightbox && lightboxImage) {
      galleryMain.addEventListener('click', function (event) {
        if (event.target.closest('.pdp-gallery__badge')) return;
        if (event.target.closest('.pdp-gallery__arrow')) return;
        if (galleryWasDragged()) return;
        var activeImage = images[activeIndex];
        if (!activeImage) return;
        lightboxImage.src = activeImage.dataset.full || activeImage.src;
        lightboxImage.alt = activeImage.alt || '';
        lightbox.showModal();
      });

      lightbox.addEventListener('click', function (event) {
        if (event.target === lightbox) lightbox.close();
      });

      document.querySelectorAll('[data-pdp-lightbox-close]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          lightbox.close();
        });
      });

      var lightboxPrev = lightbox.querySelector('[data-pdp-lightbox-prev]');
      var lightboxNext = lightbox.querySelector('[data-pdp-lightbox-next]');

      if (lightboxPrev) {
        lightboxPrev.addEventListener('click', function () {
          setActiveIndex(activeIndex - 1);
        });
      }
      if (lightboxNext) {
        lightboxNext.addEventListener('click', function () {
          setActiveIndex(activeIndex + 1);
        });
      }
      if (images.length > 1) {
        bindSwipe(lightbox, function (direction) {
          setActiveIndex(activeIndex + (direction === 'next' ? 1 : -1));
        });
      }
    }
  })();

  (function () {
    var placeholder = document.querySelector('[data-product-recommendations]');
    if (!placeholder) return;
    fetch(placeholder.dataset.url)
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var content = doc.querySelector('[data-product-recommendations-content]');
        if (content && content.children.length > 0) {
          placeholder.innerHTML = content.innerHTML;
          doc.querySelectorAll('style').forEach(function (style) {
            document.head.appendChild(style.cloneNode(true));
          });
          if (window.GasWishlist) window.GasWishlist.bindButtons(placeholder);

          var viewport = placeholder.querySelector('[data-prod-viewport]');
          var prev = placeholder.querySelector('[data-prod-prev]');
          var next = placeholder.querySelector('[data-prod-next]');
          if (viewport && prev) {
            prev.addEventListener('click', function () {
              viewport.scrollBy({ left: -viewport.clientWidth * 0.8, behavior: 'smooth' });
            });
          }
          if (viewport && next) {
            next.addEventListener('click', function () {
              viewport.scrollBy({ left: viewport.clientWidth * 0.8, behavior: 'smooth' });
            });
          }

          if (window.GasReveal) window.GasReveal.observe(placeholder.querySelector('.reveal-group'));
        }
      })
      .catch(function () {});
  })();

  (function () {
    var stickyBar = document.querySelector('[data-pdp-sticky]');
    var addBtn = document.querySelector('[data-pdp-add]');
    if (!stickyBar || !addBtn) return;

    var observer = new IntersectionObserver(
      function (entries) {
        stickyBar.dataset.visible = String(!entries[0].isIntersecting);
      },
      { threshold: 0 }
    );
    observer.observe(addBtn);

    var stickyAddBtn = stickyBar.querySelector('[data-pdp-sticky-add]');
    if (stickyAddBtn) {
      stickyAddBtn.addEventListener('click', function () {
        var form = document.querySelector('[data-pdp-form]');
        if (form) form.requestSubmit();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.querySelector('[data-recently-viewed-section]');
    if (!section) return;
    var track = section.querySelector('[data-recently-viewed-track]');
    var viewport = section.querySelector('[data-recently-viewed-viewport]');
    var prev = section.querySelector('[data-recently-viewed-prev]');
    var next = section.querySelector('[data-recently-viewed-next]');

    if (prev) {
      prev.addEventListener('click', function () {
        viewport.scrollBy({ left: -viewport.clientWidth * 0.8, behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        viewport.scrollBy({ left: viewport.clientWidth * 0.8, behavior: 'smooth' });
      });
    }

    document.addEventListener('DOMContentLoaded', function () {
      window.GasRecentlyViewed.render(track, { limit: 8 }).then(function () {
        if (track.children.length > 0) section.hidden = false;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.testimonials').forEach(function (section) {
    var viewport = section.querySelector('[data-testimonials-viewport]');
    var prev = section.querySelector('[data-testimonials-prev]');
    var next = section.querySelector('[data-testimonials-next]');
    if (!viewport) return;

    if (prev) {
      prev.addEventListener('click', function () {
        viewport.scrollBy({ left: -viewport.clientWidth * 0.8, behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        viewport.scrollBy({ left: viewport.clientWidth * 0.8, behavior: 'smooth' });
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var grid = document.querySelector('[data-wishlist-grid]');
    if (!grid || !window.GasWishlist) return;
    window.GasWishlist.render(grid);
  });

  } catch(e) { console.error(e); }
})();
})();
